import { parseError, agent, updateSessionObject } from 'utils/api'
import { notify } from '../utils/notification'
import constants from 'constants'
import { push } from 'react-router-redux'

export const UPLOADLOGS_RECEIVED_LOGS = 'UPLOADLOGS_RECEIVED_LOGS'
export const UPLOADLOGS_CPTRUSTDEEDS_RECEIVED_LOGS = 'UPLOADLOGS_CPTRUSTDEEDS_RECEIVED_LOGS'
export const UPLOADLOGS_CPLOANPACK_RECEIVED_LOGS = 'UPLOADLOGS_CPLOANPACK_RECEIVED_LOGS'
export const UPLOADLOGS_CPAMTCONFIRMATION_RECEIVED_LOGS = 'UPLOADLOGS_CPAMTCONFIRMATION_RECEIVED_LOGS'
export const UPLOADLOGS_GETING_LOGS = 'UPLOADLOGS_GETING_LOGS'
export const UPLOADLOGS_ERROR = 'UPLOADLOGS_ERROR'

const fetching = type => ({
  type,
})

const receive = (documents, type) => ({
  type,
  documents,
})

export function getUploadLogs(libraryName, folderName = '') {
  return (dispatch) => {
    dispatch(fetching(UPLOADLOGS_GETING_LOGS))
    agent.UploadLogs.getUploadLogs(libraryName, folderName)
      .then((result) => {
        if (folderName) {
          if (folderName === constants.UPLOADLOGS.CAPITALLOANS_FOLDER.TRUSTDEEDS) {
            dispatch(receive(result, UPLOADLOGS_CPTRUSTDEEDS_RECEIVED_LOGS))
          } else if (folderName === constants.UPLOADLOGS.CAPITALLOANS_FOLDER.LOANPACK) {
            dispatch(receive(result, UPLOADLOGS_CPLOANPACK_RECEIVED_LOGS))
          } else if (folderName === constants.UPLOADLOGS.CAPITALLOANS_FOLDER.AMOUNTCONFIRMATION) {
            dispatch(receive(result, UPLOADLOGS_CPAMTCONFIRMATION_RECEIVED_LOGS))
          }
        } else {
          dispatch(receive(result, UPLOADLOGS_RECEIVED_LOGS))
        }
      })
      .catch((rawError) => {
        console.error('Getting upload logs error')
        // console.error('getUploadlogs error', rawError, rawError.stack, window.location)
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching upload logs', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/uploadlogs.js